import { WebRTC, WebRTCAudio } from './webrtc';
var ɵ0 = function () {
    console.log("Initializing listener");
    var oldBeforeUnload = window.onbeforeunload;
    window.onbeforeunload = function () {
        if (oldBeforeUnload) {
            oldBeforeUnload();
        }
        WebRTCListener.onUnload();
    };
}, ɵ1 = function () {
    WebRTCAudio.loadLocalStream = this.loadLocalStream;
}, ɵ2 = function () {
    WebRTC.disconnect();
}, ɵ3 = function (onAfterSuccess, onError) {
    var fakeDestination = this.audioContext.createMediaStreamDestination();
    var mockAudioElem = document.getElementById('mock-local-stream');
    this.audioContext.createMediaElementSource(mockAudioElem).connect(fakeDestination);
    this.speaker.sourceNode.connect(this.speaker.gainNode);
    WebRTCAudio.stream.local = fakeDestination.stream;
    onAfterSuccess(WebRTCAudio.stream.local);
};
var WebRTCListener = {
    campaignId: undefined,
    agentId: undefined,
    init: ɵ0,
    //todo? not used anymore?
    // checkStatus: function () {
    //     console.log("Checking agent status");
    //     $.ajax({
    //         type: "GET",
    //         contentType: "application/json",
    //         url: "/listening/" + WebRTCListener.agentId + "/status",
    //         success: function onSuccess(data) {
    //             $("#agentDisconnected").toggle(data.disconnected);
    //             $("#agentStatus").toggle(!data.disconnected);
    //             if (!data.disconnected) {
    //                 $("#recordId").text(data.recordId);
    //                 $("#callId").text(data.callId);
    //                 $("#oneTimePhoneNumber").text(data.oneTimePhoneNumber);
    //                 $("#phoneNumberToCall").text(intlTelInputUtils.formatNumberByType(data.phoneNumberToCall, '', intlTelInputUtils.numberFormat.INTERNATIONAL));
    //                 $("#state").text(WebRTCListener.mapAgentState(data.state));
    //             }
    //             setTimeout(WebRTCListener.checkStatus, 3000);
    //         }
    //     });
    // },
    fakeLocalStream: ɵ1,
    onUnload: ɵ2,
    // mapAgentState: function (agentState) {
    //     switch (agentState) {
    //         case "SUSPENDED":
    //             return l.AGENT_STATE.SUSPENDED;
    //         case "IDLE":
    //         case "WAITING_FOR_RECORD":
    //         case "WAITING_FOR_MSISDN":
    //             return l.AGENT_STATE.WAITING_FOR_RECORD;
    //         case "WAITING_FOR_ANSWER":
    //             return l.AGENT_STATE.WAITING_FOR_ANSWER;
    //         case "TALKING":
    //         case "SAVED_AND_TALKING":
    //             return l.AGENT_STATE.TALKING;
    //         case "NOT_SAVED_AND_FINISHED_TALKING":
    //             return l.AGENT_STATE.NOT_SAVED_AND_FINISHED_TALKING;
    //         case "PAUSED":
    //             return l.AGENT_STATE.PAUSED;
    //         case "SAGE_COMMUNICATION":
    //             return l.AGENT_STATE.SAGE_COMMUNICATION;
    //         default:
    //             return l.AGENT_STATE.OFFLINE;
    //     }
    // },
    loadLocalStream: ɵ3
};
window['WebRTCListener'] = WebRTCListener;
export { ɵ0, ɵ1, ɵ2, ɵ3 };
//# sourceMappingURL=listener.js.map